import React from 'react';

const Experience = () => {

    return (
        <>
            <section className="resume-section" id="experience">
                <div className="resume-section-content">
                    <h2 className="mb-5 text-primary">Experience</h2>
                    <div className="d-flex flex-column flex-md-row justify-content-between mb-5">
                        <div className="flex-grow-1">
                            <h3 className="mb-0">Social support staff</h3>
                            <div className="subheading mb-3">Pandechaion – Herberge e.V, Leipzig</div>
                            <ul>
                                <li>Supporting for social care</li>
                                <li>Consultation for asylum and general administrative procedures</li>
                                <li>Teaching of language courses</li>
                            </ul>
                        </div>
                        <div className="flex-shrink-0"><span className="text-primary">(10/2018 - 03/2019)</span></div>
                    </div>
                    <div className="d-flex flex-column flex-md-row justify-content-between mb-5">
                        <div className="flex-grow-1">
                            <h3 className="mb-0">Computer Technician & Teacher</h3>
                            <div className="subheading mb-3">Echo100plus (NGO), Leros, Greece</div>
                            <ul>
                                <li>Preparing and running computer management courses for
                                    residents on the island of Leros</li>
                                <li>Provide technical support to Echo100plus</li>
                            </ul>
                        </div>
                        <div className="flex-shrink-0"><span className="text-primary">(03/2017 - 06/2017)</span></div>
                    </div>
                    <div className="d-flex flex-column flex-md-row justify-content-between mb-5">
                        <div className="flex-grow-1">
                            <h3 className="mb-0">Founder and owner of a computer and mobile phone shop</h3>
                            <div className="subheading mb-3">Icon Centre, Damascus, Syria</div>
                            <ul>
                                <li>Sales: Dealt with customers’ requests and marketing the Centre</li>
                                <li>Technical: Repairing and upgrading old computers and phones for
                                    resale</li>
                                <li>Administration: Managing team of five employees, accounting and bookkeeping</li>
                            </ul>
                        </div>
                        <div className="flex-shrink-0"><span className="text-primary">(08/2006 – 05/2016)</span></div>
                    </div>
                    <div className="d-flex flex-column flex-md-row justify-content-between mb-5">
                        <div className="flex-grow-1">
                            <h3 className="mb-0">Director of Automating Signalling Systems</h3>
                            <div className="subheading mb-3">Ministry of Electricity, Damascus, Syria</div>
                            <ul>
                                <li>Supervising the reading of electricity metres in Damascus,
                                    analysing them and ensuring their quality of data before
                                    transferring them to the Ministry's billing system</li>
                                <li>Manage a direct team of nine employees and delivery of external
                                    data for a team of 90 employees</li>
                            </ul>
                        </div>
                        <div className="flex-shrink-0"><span className="text-primary">(09/2011 – 05/2016)</span></div>
                    </div>
                    <div className="d-flex flex-column flex-md-row justify-content-between mb-5">
                        <div className="flex-grow-1">
                            <h3 className="mb-0">Supervisor, Maintenance Department</h3>
                            <div className="subheading mb-3">Modern Building Contracting Company, Dubai, UAE</div>
                            <ul>
                                <li>Managing and controlling the electrical operating systems in all
                                    "Modern Building Company" sites in UAE</li>
                            </ul>
                        </div>
                        <div className="flex-shrink-0"><span className="text-primary">(11/2008 – 09/2009)</span></div>
                    </div>
                    <div className="d-flex flex-column flex-md-row justify-content-between mb-5">
                        <div className="flex-grow-1">
                            <h3 className="mb-0">Computer Systems Designer (Part-time)</h3>
                            <div className="subheading mb-3">Light Angel Trading, Damascus, Syria</div>
                            <ul>
                                <li>Building and managing relationships with suppliers, offering
                                    advisory services to customers for the “Computer Systems
                                    Designer”</li>
                            </ul>
                        </div>
                        <div className="flex-shrink-0"><span className="text-primary">(09/2004 – 02/2011)</span></div>
                    </div>
                    <div className="d-flex flex-column flex-md-row justify-content-between mb-5">
                        <div className="flex-grow-1">
                            <h3 className="mb-0">Computer Assistant (Part-time)</h3>
                            <div className="subheading mb-3">Alhakeim Company, Damascus, Syria</div>
                            <ul>
                                <li>Providing computer maintenance services (software & hardware)</li>
                                <li>Setting up small computer networks for clients</li>
                            </ul>
                        </div>
                        <div className="flex-shrink-0"><span className="text-primary">(10/1997 – 07/2000)</span></div>
                    </div>
                </div>
            </section>
            <hr className="m-0" />
        </>
    )
};

export default Experience;
